import * as THREE from 'node_modules/three/build/three.module.js';
import { Vector3 } from 'three';
import { TweenMax } from 'gsap';
import {
  StateService
} from 'src/app/services';

export class Lights {
  public dirLight: any;
  public hemiLight: any;
  public spotLight: any;
  public welcomeLight: any;
  public lightIntensity: any = 16;
  public scene: any;
  constructor(
    // private logger: Logger,
    public sceneparam: any, public centerPoint: Vector3) {
    this.scene = sceneparam;
    console.log('Light scene + ', this.scene)
    this.init();
  }

  init(): void {
    this.hemiLight = new THREE.HemisphereLight(0xffffff, 0x404040);

    this.scene.add(this.hemiLight);

    this.scene.add(new THREE.AmbientLight(0x404040, .8));


    this.dirLight = new THREE.DirectionalLight(0x404040);
    // this.moveLights(this.stateSvc.coordinates[this.stateSvc.states.WELCOME]);
    // this.dirLight.castShadow = true;
    this.dirLight.shadow.camera.top = 180;
    this.dirLight.shadow.camera.bottom = -100;
    this.dirLight.shadow.camera.left = -2000;
    this.dirLight.shadow.camera.right = 2000;
    this.dirLight.position.add(this.centerPoint);
    this.scene.add(this.dirLight);

    this.welcomeLight = new THREE.PointLight(0x404040, this.lightIntensity, 250, 1.0);
    this.welcomeLight.position.set(27, 325, 1250);
    this.welcomeLight.position.add(this.centerPoint);
    this.scene.add(this.welcomeLight);

    const l1 = new THREE.PointLight(0x404040, this.lightIntensity, 600, 1.0);
    l1.position.set(20, 500, 1350);
    // this.scene.add(l1);


    this.spotLight = new THREE.SpotLight(0xffffff);
    // const spotLight = new THREE.SpotLight(0x402020);
    // this.spotLight.position.set(100, 2000, 100);
    this.spotLight.position.add(this.centerPoint);
    this.spotLight.position.y = 2000;
    this.spotLight.intensity = .7;

    this.spotLight.castShadow = true;

    this.spotLight.shadow.mapSize.width = 4096;
    this.spotLight.shadow.mapSize.height = 4096;

    this.spotLight.shadow.camera.near = 500;
    this.spotLight.shadow.camera.far = 8000;
    this.spotLight.shadow.camera.fov = 30;

    this.scene.add(this.spotLight);


    // Saved
    if (window.location.host.indexOf('localhost') > -1) {

      const sphere = new THREE.SphereGeometry(5, 16, 8);
      this.welcomeLight.add(new THREE.Mesh(sphere, new THREE.MeshBasicMaterial({ color: 0x404040 })));
      // l1.add(new THREE.Mesh(sphere, new THREE.MeshBasicMaterial({ color: 0xff0000 })));
      const spotLightHelper = new THREE.SpotLightHelper(this.spotLight);
      this.scene.add(spotLightHelper);
    }
    // const shadowCameraHelper = new THREE.CameraHelper(spotLight.shadow.camera);
    // this.scene.add(shadowCameraHelper);

    // this.moveLights(this.stateSvc.coordinates[this.stateSvc.states.WELCOME]);
    // this.dirLight.castShadow = true;
    // this.dirLight.penumbra = 0.1;
    // this.dirLight.decay = 2;
    // this.dirLight.shadow.focus = .5;
    // // this.dirLight.shadow.mapSize.width = 256;
    // // this.dirLight.shadow.mapSize.height = 256;
    // // this.dirLight.shadow.camera.near = 10;
    // // this.dirLight.shadow.camera.far = 200;
    // // this.dirLight.shadow.focus = 1;
    // this.scene.add(this.dirLight);

    // const spotLightHelper = new THREE.SpotLightHelper(this.dirLight);
    // this.scene.add(spotLightHelper);

    // const shadowCameraHelper = new THREE.CameraHelper(this.dirLight.shadow.camera);
    // this.scene.add(shadowCameraHelper);

  }
  moveLights(tar: any): void {
    // return;

    this.spotLight.target = tar
    console.log("move da lights", tar, this.spotLight.target.position);

    TweenMax.to(this.spotLight.position, 1, {
      x: tar.position.x + this.centerPoint.x,
      // y: vec.y,
      z: tar.position.z + this.centerPoint.z
    });
    // const spotLightHelper = new THREE.SpotLightHelper(this.spotLight, 0xffffff * Math.random());
    // this.scene.add(spotLightHelper);
  }

  // Saved: Tony. 
  // moveLights(vec: Vector3): void {
  //   // return;
  //   console.log("move da lights", vec, this.spotLight.target.position);
  //   TweenMax.to(this.spotLight.target.position, 1, {
  //     x: vec.x + this.centerPoint.x,
  //     // y: vec.y,
  //     z: vec.z + this.centerPoint.z
  //   });

  //   // TweenMax.to(this.dirLight, 1, {
  //   //     angle:( Math.random() * 0.7 ) + 0.1
  //   // });
  // }


  changeIntensity(n: any): void {
    this.lightIntensity = n;
    this.welcomeLight.power = this.lightIntensity * 4 * Math.PI;
    console.log('this.welcomeLight.intesity', n);

    // TweenMax.to(this.dirLight, 1, {
    //     angle:( Math.random() * 0.7 ) + 0.1
    // });
  }
}
